import {createAction} from "@reduxjs/toolkit";

export const setFilteredArticles = createAction('SET__FILTERED_ARTICLES');